<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition"
        content-class="nv-dialog">
            <v-card flat tile class="nv-shell">
                <v-form name="form" class="nv-shell__form" @submit.prevent="saveSell">
                    <ValidationObserver ref="refVenta" v-slot="{ invalid, validated }" tag="div" class="nv-shell__inner">

                        <!-- ================= barra ================= -->
                        <v-toolbar dark color="primary" flat class="nv-toolbar">
                            <v-btn icon dark @click.native="handleModal" aria-label="Cerrar venta">
                                <v-icon>fas fa-times-circle</v-icon>
                            </v-btn>
                            <v-toolbar-title class="nv-toolbar__title">
                                Nueva venta
                                <span v-if="currentSucursalName" class="nv-toolbar__branch">· {{ currentSucursalName }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="nv-submit" type="submit" depressed
                            :disabled="isSubmitting || invalid || !validated"
                            :loading="isSubmitting">
                                <v-icon small left>fas fa-save</v-icon>
                                {{ titleButtonOut }}
                            </v-btn>
                        </v-toolbar>

                        <!-- ================= cuerpo ================= -->
                        <div class="nv-body form-page form-compact">
                            <v-row>
                                <v-col cols="12" :md="computedCol">

                                    <div class="form-sections">
                                    <!-- ---------- operación ---------- -->
                                    <section class="form-section">
                                        <div class="form-section__head">
                                            <h2 class="form-section__title">Operación</h2>
                                            <span class="form-section__meta">Los campos con * son obligatorios</span>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="4">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="tipoSalida" item-text="nombre" item-value="id"
                                                    v-model="venta.tipoSalidaId" label="Tipo de salida" required
                                                    filled outlined prepend-inner-icon="fas fa-sign-out-alt"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeMovement">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="sucursales" item-text="nombre" item-value="id"
                                                    v-model="venta.sucursalEnviaId" label="Sucursal que envía" required
                                                    filled outlined prepend-inner-icon="fas fa-store-alt"
                                                    hide-details="auto" :readonly="!isAdmin" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeMovement">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="listEntradaDetalle" item-text="ticketFolio" item-value="id"
                                                    v-model="venta.entradaDetalleId" label="Entrada de inventario" required
                                                    filled outlined prepend-inner-icon="fas fa-drumstick-bite"
                                                    hide-details="auto" chips small-chips :error-messages="errors">
                                                        <template v-slot:no-data>
                                                            <v-list-item>
                                                                <v-list-item-title>
                                                                    No hay entradas<strong> para la sucursal seleccionada</strong>
                                                                </v-list-item-title>
                                                            </v-list-item>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            {{ item.ticketFolio }} - {{ item.producto.nombre }} {{ item.producto.descripcion }} Existencia: <strong>{{ item.existencia }}</strong>
                                                        </template>
                                                        <template v-slot:selection="{ attr, on, item, selected }">
                                                            <v-chip v-bind="attr" :input-value="selected" color="primary"
                                                            class="white--text font-weight-medium" v-on="on">
                                                                <span v-text="item.producto.nombre + ' ' + item.producto.descripcion + ' · Existencia: ' + item.existencia + ' · ' + item.ticketFolio"></span>
                                                            </v-chip>
                                                        </template>
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeTransfer">
                                                <ValidationProvider :rules="modeMerma ? '' : 'required'" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="excludeSucursalEnvia" item-text="nombre" item-value="id"
                                                    v-model="venta.sucursalRecibeId" label="Sucursal que recibe"
                                                    filled outlined prepend-inner-icon="fas fa-store-alt"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeSell">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="clientes" item-text="nombreComercial" item-value="idCliente"
                                                    v-model="venta.clienteId" label="Cliente" required
                                                    filled outlined prepend-inner-icon="fas fa-user"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeSell && venta.clienteId == 29">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="employees" item-text="nombreCompleto" item-value="id"
                                                    v-model="venta.employeeId" label="Empleado" required
                                                    filled outlined prepend-inner-icon="fas fa-user-tie"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeSell && clientesSucursal.length > 0">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="clientesSucursal" item-text="name" item-value="id"
                                                    v-model="venta.clienteSucursalId" label="Sucursal del cliente" required
                                                    filled outlined prepend-inner-icon="fas fa-store"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                        </v-row>
                                    </section>

                                    <!-- ---------- pago y entrega ---------- -->
                                    <section class="form-section">
                                        <div class="form-section__head">
                                            <h2 class="form-section__title">Pago y entrega</h2>
                                            <span class="form-section__meta" v-if="currencyLabel">Moneda: {{ currencyLabel }}</span>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="4" v-if="modeSell">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="tipoPagos" item-text="formaPago" item-value="id"
                                                    v-model="venta.tipoPagoId" label="Medio de pago" required
                                                    filled outlined prepend-inner-icon="fas fa-money-check-alt"
                                                    hide-details="auto" :error-messages="errors" :disabled="!hasCredit">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeSell && venta.tipoPagoId === 1">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-autocomplete :items="paymentMethod" item-text="name" item-value="value"
                                                    v-model="venta.paymentMethod" label="Método de pago" required
                                                    filled outlined prepend-inner-icon="fas fa-credit-card"
                                                    hide-details="auto" :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="enableOperationNumber">
                                                <ValidationProvider rules="required" v-slot="{ errors }" :immediate="true">
                                                    <v-text-field v-model="venta.operationNumber"
                                                    label="Número o referencia de la operación" required
                                                    filled outlined prepend-inner-icon="fas fa-hashtag"
                                                    :counter="100" :error-messages="errors">
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4">
                                                <div class="nv-datepicker">
                                                    <SingleCalendar refElement="deliveryDate" :input-date.sync="venta.deliveryDate"
                                                    title="Fecha de entrega" :min-date="today" margin-top="mt-0"/>
                                                </div>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="modeMerma || enableOperationNumber">
                                                <v-file-input v-model="fileEvidences" color="primary" counter
                                                :show-size="true" :rules="fileRules" filled outlined
                                                label="Adjuntar archivo" :multiple="false" placeholder="Seleccionar archivo"
                                                prepend-inner-icon="fas fa-paperclip">
                                                    <template v-slot:selection="{ index, text }">
                                                        <v-chip v-if="index < 2" color="primary" dark label small>
                                                            {{ text }}
                                                        </v-chip>
                                                        <span v-else-if="index === 2" class="text-caption grey--text text--darken-1 mx-2">
                                                            +{{ (fileEvidences?.length || 0) - 2 }} archivos
                                                        </span>
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        </v-row>

                                        <!-- El saldo vive junto al medio de pago: es la respuesta a
                                             "¿puede pagar a crédito?" y solo importa cuando el medio
                                             de pago es crédito. La barra mide cuánto del saldo
                                             consume esta venta. El detalle completo está en el menú. -->
                                        <v-menu v-if="showCreditSummary" offset-y nudge-bottom="10" min-width="320" max-width="420">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button type="button" class="nv-credit" v-bind="attrs" v-on="on"
                                                :class="{ 'nv-credit--short': !creditIsEnough }"
                                                :aria-label="`Saldo disponible del cliente: ${creditClient.balanceNatural}. Ver detalle del crédito.`">
                                                    <span class="nv-credit__col">
                                                        <span class="nv-credit__label">
                                                            Saldo disponible
                                                            <v-icon small class="nv-credit__info">fas fa-info-circle</v-icon>
                                                        </span>
                                                        <span class="nv-credit__value">{{ creditClient.balanceNatural }}</span>
                                                    </span>
                                                    <span class="nv-credit__meter" aria-hidden="true">
                                                        <span class="nv-credit__fill" :style="{ width: creditUsage + '%' }"></span>
                                                    </span>
                                                    <span class="nv-credit__col nv-credit__col--end">
                                                        <span class="nv-credit__label">{{ creditIsEnough ? 'Esta venta' : 'Excede el saldo' }}</span>
                                                        <span class="nv-credit__value">{{ importeNatural }}</span>
                                                    </span>
                                                </button>
                                            </template>
                                            <DetailCreditClient :credit-client="creditClient" class="nv-credit__panel"/>
                                        </v-menu>
                                    </section>

                                    <!-- ---------- productos ---------- -->
                                    <addProducto :venta.sync="venta" :products.sync="products" ref="myCartProduct"
                                    :listEntradaDetalle.sync="listEntradaDetalle"
                                    @getDetailProduct="getDetailProduct" @addProductCart="addProductCart">
                                    </addProducto>
                                    </div>
                                </v-col>

                                <!-- ---------- contexto ---------- -->
                                <v-col cols="12" md="3" v-if="modeSell">
                                    <div class="nv-stamp surface-card">
                                        <span class="nv-stamp__label">Hoy</span>
                                        <span class="nv-stamp__value">{{ fullDateNatural }}</span>
                                    </div>

                                    <div class="rail-panel" v-if="clienteSeleccionado">
                                        <div class="rail-panel__head">
                                            <span class="rail-panel__title">Cliente</span>
                                        </div>
                                        <div class="nv-client">
                                            <span class="nv-client__name">{{ clienteSeleccionado.nombreComercial }}</span>
                                            <v-chip x-small label :color="hasCredit ? 'success' : 'grey'" dark class="nv-client__chip">
                                                <v-icon x-small left>{{ hasCredit ? 'fas fa-check-circle' : 'fas fa-ban' }}</v-icon>
                                                {{ hasCredit ? 'Crédito autorizado' : 'Sin crédito' }}
                                            </v-chip>
                                        </div>
                                    </div>

                                    <div class="rail-panel" v-if="cartItemCount > 0">
                                        <div class="rail-panel__head">
                                            <span class="rail-panel__title">Resumen</span>
                                        </div>
                                        <table class="rail-table">
                                            <tbody>
                                                <tr><td>Productos</td><td>{{ cartItemCount }}</td></tr>
                                                <tr><td>Piezas</td><td>{{ cartPieces }}</td></tr>
                                                <tr v-if="cartWeight > 0"><td>Peso</td><td>{{ cartWeight }} kg</td></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <DetailProductInStock :product-in-stock="detailProduct" :cart="productCart" v-if="showDetail"/>
                                </v-col>
                            </v-row>
                        </div>

                        <!-- ================= pie: el único total ================= -->
                        <div class="total-bar" :class="{ 'total-bar--negative': modeMerma }">
                            <div class="total-bar__total">
                                <span class="total-bar__icon" aria-hidden="true">
                                    <v-icon small>fas fa-dollar-sign</v-icon>
                                </span>
                                <div class="total-bar__figure">
                                    <span class="total-bar__label">Total</span>
                                    <span class="total-bar__value">{{ importeNatural }}</span>
                                </div>
                            </div>

                            <div class="total-bar__meta">
                                <span class="total-bar__chip">{{ cartItemCount }} {{ cartItemCount === 1 ? 'producto' : 'productos' }}</span>
                                <span class="total-bar__chip" v-if="cartWeight > 0">{{ cartWeight }} kg</span>
                                <span class="total-bar__chip" v-if="currencyLabel">{{ currencyLabel }}</span>
                            </div>
                        </div>

                    </ValidationObserver>
                </v-form>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import ProductoDataService from "@/service/producto/ProductoDataService";
import ProductoListaPrecioDataService from "@/service/producto/ProductoListaPrecioDataService";
import VentaDataService from '@/service/venta/VentaDataService';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import addProducto from './addProduct.vue';
import DetailProductInStock from "./DetailProductInStock.vue";
import { getFullDateTodayNatural, getHourNowNatural, getToday } from "@/utils/DateUtil";
import { getFormatCurrency, toNumber, roundMoney } from "@/utils/CurrencyUtil";
import EntradaDetalleDataService from "@/service/entrada/EntradaDetalleDataService";
import UsuarioDataService from "@/service/usuario/UsuarioDataService";
import DetailCreditClient from "../cliente/DetailCreditClient.vue";
import clienteDataService from '@/service/cliente/clienteDataService';
import VentaEvidenceFileService from "@/service/venta/evidences/VentaEvidenceFileService";
import SingleCalendar from "@/components/shared/SingleCalendar.vue";
import EmpleadoDataService from "@/service/empleado/empleadoDataService";
import ClienteSucursalDataService from "@/service/cliente/clienteSucursalDataService";
import { showSuccessAlert, showErrorAlert, showInfoAlert } from "@/helpers/swalHelper";
import { extractMessage } from "@/helpers/errorHelper";
import { can, CAP } from '@/service/permiso/capacidades';

export default {
    name: "NuevaVenta",
    components: { addProducto, DetailProductInStock, DetailCreditClient, SingleCalendar },
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        initialize: { type: Function },
        monedas: { type: Array, default: () => [] },
        clientes: { type: Array, default: () => [] },
        tipoSalida: { type: Array, default: () => [] },
        tipoPagos: { type: Array, default: () => [] },
        sucursales: { type: Array, default: () => [] }
    },
    created () { this.getAllServices() },
    data () {
        // `data()` no puede leer `this`, así que la fecha de hoy se calcula una
        // sola vez aquí y alimenta tanto el campo como el mínimo del calendario.
        const today = getToday().toFormat('yyyy-MM-dd');
        return {
            products:   [],
            services:   [],
            employees:  [],
            clientesSucursal: [],
            listEntradaDetalle: [],
            detailProduct:  [],
            today,
            venta: {
                sucursalEnviaId: null,
                sucursalRecibeId: null,
                clienteId:      null,
                employeeId:     null,
                clienteSucursalId: null,
                entradaDetalleId: null,
                tipoPagoId:     1,
                tipoMonedaId:   1,
                tipoSalidaId:   1,
                ticketFolio:    '',
                total:          0,
                productoId:     null,
                eliminado:      false,
                paymentMethod:  '',
                operationNumber: '',
                deliveryDate:   today,
            },
            creditClient: {},
            listaPrecioRequestId: 0,
            productCart: [],
            paymentMethod: [ 'EFECTIVO', 'TRANSFERENCIA', 'CHEQUE'],
            search: null,
            isLoading: false,
            fileEvidences: undefined,
            fileRules: [
                value => !value || value.size < 5000000 || 'El archivo debe ser menor a 5 MB!'
            ],
            isSubmitting: false,
        }
    },
    methods: {
        // TO GET ALL PRODUCTS in MERMAS and SALIDAS.
        async getAllProduct(){ this.products = await ProductoDataService.findAll().then( resp => resp.data ) || [] },
        async getAllServices(){
            const typeService = true;
            this.services = await ProductoDataService.findAll(typeService).then( resp => resp.data ) || []
        },
        async getAllEmployees(){
            this.employees = await EmpleadoDataService.all().then( resp => resp.data ) || [];
        },
        async getClientSucursal( clientId ) {
            try {
                const result = await ClienteSucursalDataService.findAllByClient( clientId );
                this.clientesSucursal = result.data;
            } catch ( error ) {
                this.clientesSucursal = [];
                showErrorAlert({
                    title: 'No se pudieron obtener las sucursales del cliente',
                    text: extractMessage( error )
                });
            }
        },
        async getUltimateSell(){
            this.ultimateSell = await VentaDataService.ultimateSell().then( resp => resp.data.row[0] ) || [];
            this.venta.ticketFolio = this.ultimateSell.ticketFolio;
        },
        // El crédito se carga aquí, no en el panel que lo muestra. La venta a
        // crédito necesita el saldo para decidir ANTES de que el usuario
        // abra el detalle: si el panel fuera el único que lo pide, el saldo
        // no existiría hasta abrirlo y la validación quedaría sin datos.
        async getCreditClient( clientId ){
            if( !clientId ){
                this.creditClient = {};
                return;
            }
            try {
                const result = await clienteDataService.getDetailCredit( clientId );
                this.creditClient = result.data || {};
            } catch ( error ) {
                // Fail-closed: sin saldo conocido, la venta a crédito se bloquea.
                this.creditClient = {};
                showErrorAlert({
                    title: 'No se pudo verificar el crédito del cliente',
                    text: 'No fue posible obtener el saldo del cliente, por lo que no se puede registrar una venta a crédito.'
                });
            }
        },

        async getListaPrecioProducto( clienteId ){
            // Se descarta cualquier respuesta anterior para no aplicar precios de otro cliente.
            const requestId = ++this.listaPrecioRequestId;
            this.products = [];
            let productPrice = [];
            try {
                const resp = await ProductoListaPrecioDataService.findByClienteId( clienteId );
                productPrice = resp.data || [];
            } catch ( err ) {
                showErrorAlert({
                    title: 'Error al obtener la lista de precios',
                    text: extractMessage( err )
                });
                productPrice = [];
            }
            if( requestId !== this.listaPrecioRequestId ){
                return;
            }
            if( productPrice.length == 0 ){
                showErrorAlert({
                    title: 'No hay precio asignado para este cliente',
                    text: 'No es posible vender sin una lista de precios. Solicita que tu administrador de clientes asigne una.'
                });
            } else {
                const products = productPrice.map( prodClient => {
                    const product = prodClient.producto;
                    product.precioVenta = prodClient.precioVenta;
                    product.minPrice = prodClient.minPrice;
                    product.listaPrecioId = prodClient.listaPrecioId;
                    return product;
                });
                const services = this.services.map( service => {
                    const product = service;
                    product.precioVenta = service.amountSell;
                    product.minPrice = service.amountSell;
                    product.listaPrecioId = null;
                    return product;
                })
                this.products = [...products, ...services];
            }
        },
        addProductCart(products){
            this.productCart = products;
            this.venta.total = products.reduce( (acm, item) => acm + toNumber(item.total, 0), 0 );
        },
        getDetailProduct( data ){
            this.detailProduct = data;
        },
        getListaEntradaDetalle( sucursalId, typeOutId ){
            EntradaDetalleDataService.getEntradaDetalleBySucursal( sucursalId, typeOutId ).then( result => {
                const data = result.data || [];
                this.listEntradaDetalle = (typeOutId == 4)
                ? data.filter(prod => prod?.producto?.hasProcess)
                : data;
            }).catch( err => {
                showErrorAlert({ title: 'No se encontraron entradas', text: extractMessage( err ) });
            })
        },
        selectedProductInEntradaDetalle( entradaDetalleId ){
            if( this.listEntradaDetalle.length > 0 && entradaDetalleId > 0 ){
                this.products = this.listEntradaDetalle.filter( productEntry => productEntry.id == entradaDetalleId )
                .map( productEntryDetail => {
                    let product = productEntryDetail.producto;
                    product.precioVenta = productEntryDetail.precioUnitario;
                    product.minPrice = productEntryDetail.precioUnitario;
                    product.listaPrecioId = null
                    product.entradaDetailId = productEntryDetail.id
                    return product;
                })
            }
        },
        allowToSell(){
            if( this.modeSell && this.venta.tipoPagoId == 2 ){
                const balance = toNumber(this.creditClient?.balance);
                if( balance === null ){
                    showErrorAlert({
                        title: 'No se pudo verificar el crédito del cliente',
                        text: 'No fue posible obtener el saldo del cliente, por lo que no se puede registrar una venta a crédito.'
                    });
                    return false;
                }
                const total = toNumber(this.venta.total, 0);
                const { balanceNatural, allowToBuy } = this.creditClient;
                if( total > balance && !allowToBuy ){
                    showErrorAlert({
                        title: 'Crédito insuficiente',
                        text: `El total de la venta es ${this.importeNatural} y el saldo disponible es ${balanceNatural}.`
                    });
                    return false;
                }
            }
            return true;
        },
        async uploadEvidences(ventaId) {
            try {
                const rsp = await VentaEvidenceFileService.uploadEvidence(this.fileEvidences, ventaId);
                this.initialize();
                this.handleModal();
                this.fileEvidences = undefined;
                showSuccessAlert({
                    title: `${this.getTitleModule} registrada`,
                    text: rsp.data.message
                });
            } catch (err) {
                this.handleModal();
                this.initialize();
                this.fileEvidences = undefined;
                showErrorAlert({
                    title: 'La venta se registró, pero la evidencia no se pudo subir',
                    text: 'Puedes adjuntar el archivo más tarde desde el detalle de la venta.'
                });
            }
        },
        async saveSell(){
            if (this.isSubmitting) return;

            const isValid = await this.$refs.refVenta.validate();
            if( !isValid ){
                showErrorAlert({
                    title: `${this.getTitleModule} no registrada`,
                    text: 'Revisa los campos marcados en rojo antes de guardar.'
                });
                return;
            }

            if( this.productCart.length === 0 ){
                showInfoAlert({
                    title: `No se puede guardar la ${this.getTitleModule}`,
                    text: 'Agrega al menos un producto al carrito.'
                });
                return;
            }

            if( !this.allowToSell() ) return;

            this.isSubmitting = true;
            try {
                const response = await VentaDataService.create( this.venta, this.productCart );
                if( response.status == 200 ){
                    if (this.fileEvidences !== undefined && (this.modeMerma || this.enableOperationNumber)) {
                        await this.uploadEvidences(response.data.id);
                    } else {
                        this.initialize();
                        this.handleModal();
                        this.fileEvidences = undefined;
                        showSuccessAlert({
                            title: `${this.getTitleModule} registrada`,
                            text: response.data.message
                        });
                    }
                }
            } catch (error) {
                showErrorAlert({
                    title: `${this.getTitleModule} no registrada`,
                    text: extractMessage( error )
                });
            } finally {
                this.isSubmitting = false;
            }
        }
    },
    watch: {
        hasCredit: function( newValue ){
            // El pago a credito solo esta disponible para clientes con credito autorizado.
            if( !newValue ){
                this.venta.tipoPagoId = 1;
            }
        },
        'venta.tipoSalidaId': function( newValue ){
            this.venta.sucursalRecibeId = null
            const currentSucursalId = SucursalDataService.getCurrentSucursalId();
            if([2, 4].includes( newValue ) && currentSucursalId != null){
                this.venta.sucursalEnviaId = currentSucursalId;
                this.venta.sucursalRecibeId = currentSucursalId;
            }
            if ([2, 3, 4].includes(newValue)) {
                this.venta.sucursalEnviaId = currentSucursalId;
                this.venta.clienteId = null; // Reset client ID
                this.getListaEntradaDetalle( this.venta.sucursalEnviaId, newValue );
            }
            this.$refs.myCartProduct.productCart = [];
            this.products = [];
            this.venta.entradaDetalleId = null;
            if( newValue == 1 ){
                this.detailProduct = [];
                if( this.venta.clienteId != null ){
                    this.getListaPrecioProducto( this.venta.clienteId );
                }
            }
        },
        'venta.sucursalEnviaId': function( newValue ){
            if( newValue != null ){
                this.getListaEntradaDetalle( newValue, this.venta.tipoSalidaId );
            }
        },
        'venta.clienteId':function( newValue ){
            if( newValue != null ){
                // Se limpia el credito del cliente anterior: hasta que llegue el dato del nuevo
                // cliente la venta a credito queda bloqueada (fail-closed).
                this.creditClient = {};
                // TODO: Refactor this code in the future cause it is hardcoded the client with ID 29 reference to CONSUMO PERSONAL
                if(newValue == 29){
                    this.getAllEmployees();
                } else {
                    this.venta.employeeId = null;
                }
                this.venta.clienteSucursalId = null;
                this.getClientSucursal( newValue );
                this.getCreditClient( newValue );
                this.$refs.myCartProduct.productCart = [];
                this.getListaPrecioProducto( newValue );
            }
        },
        'venta.entradaDetalleId': function( newValue ){
            this.$refs.myCartProduct.productCart = [];
            this.products = [];
            if( newValue != null ){
                this.selectedProductInEntradaDetalle( newValue );
            }
        },
        search() {
            if (this.productos.length > 0) return
            this.isLoading = true
            ProductoDataService.findAll().then( resp => {
                this.productos = resp.data.rows;
            }).catch( err => {
                showErrorAlert({ title: 'Error al cargar los productos', text: extractMessage( err ) });
            }).finally( () => this.isLoading = false )
        }
    },
    computed: {
        isAdmin(){ return can(CAP.ADMIN, UsuarioDataService.getUserRoles()); },
        fullDateNatural() { return getFullDateTodayNatural() + " - " + getHourNowNatural(); },
        modeSell() { return this.venta.tipoSalidaId == 1 || this.venta.tipoSalidaId == 5; },
        modeMovement() { return this.venta.tipoSalidaId == 2 || this.venta.tipoSalidaId == 3 || this.venta.tipoSalidaId == 4; },
        modeMerma() { return this.venta.tipoSalidaId == 2; },
        modeTransfer() { return this.venta.tipoSalidaId == 3 },
        modeProcess() { return this.venta.tipoSalidaId == 4; },
        modeInternalSell() { return this.venta.tipoSalidaId == 5; },
        showDetail() {
            return this.modeSell && this.detailProduct.length > 0;
        },
        excludeSucursalEnvia() {
            return this.sucursales.filter( sucursal => sucursal.id != this.venta.sucursalEnviaId );
        },
        enableOperationNumber(){
            return (this.venta.paymentMethod == "TRANSFERENCIA" || this.venta.paymentMethod == "CHEQUE") && this.venta.tipoPagoId == 1 && !this.modeMovement;
        },
        isContado(){ return this.venta.tipoPagoId == 1; },
        checkClient(){ return this.venta.clienteId == this.creditClient.idCliente; },
        hasCredit(){
            if( this.venta.clienteId != null ){
                const cliente = this.clientes.find( client => client.idCliente == this.venta.clienteId );
                return cliente?.hasCredito === true;
            }
            return false;
        },
        computedCol() {
            return !this.modeSell ? 12 : 9
        },
        // El importe se formatea con CurrencyUtil: es el número que va al pie.
        importeNatural(){
            return getFormatCurrency( toNumber(this.venta.total, 0), '$' );
        },
        cartItemCount(){
            return this.productCart.length;
        },
        cartWeight(){
            return roundMoney(
                this.productCart.reduce( (acc, item) => acc + toNumber(item.kg, 0), 0 )
            );
        },
        currencyLabel(){
            const moneda = this.monedas.find( moneda => moneda.id == this.venta.tipoMonedaId );
            return moneda ? moneda.moneda : '';
        },
        currentSucursalName(){
            const sucursalId = SucursalDataService.getCurrentSucursalId();
            if( sucursalId == null ) return '';
            const sucursal = this.sucursales.find( sucursal => sucursal.id == sucursalId );
            return sucursal ? sucursal.nombre : '';
        },
        getTitleModule(){
            const titles = { 1: 'Venta', 2: 'Merma', 3: 'Salida por traspaso', 4: 'Salida por proceso', 5: 'Venta Interna' };
            return titles[this.venta.tipoSalidaId] || 'Venta';
        },
        titleButtonOut(){
            const module = this.getTitleModule.toLowerCase();
            return (this.isSubmitting ? 'Guardando' : 'Guardar') + ' ' + module;
        },
        // El saldo solo se muestra cuando el cliente tiene crédito autorizado
        // y el saldo ya llegó. Un saldo desconocido NO se muestra como $0:
        // la venta a crédito queda bloqueada y el aviso va en el guardado.
        // Solo cuando el medio de pago es crédito (id 2): en una venta de
        // contado el saldo no decide nada y sería ruido.
        showCreditSummary(){
            return this.modeSell && this.hasCredit && this.venta.tipoPagoId == 2
                && this.creditClient.balanceNatural != null;
        },
        // Porcentaje del saldo que consume esta venta, acotado a 0-100 para la barra.
        creditUsage(){
            const balance = toNumber(this.creditClient?.balance);
            if( !balance || balance <= 0 ) return 100;
            const pct = ( toNumber(this.venta.total, 0) / balance ) * 100;
            return Math.min(100, Math.max(0, Math.round(pct)));
        },
        clienteSeleccionado(){
            if( !this.modeSell || this.venta.clienteId == null ) return null;
            return this.clientes.find( client => client.idCliente == this.venta.clienteId ) || null;
        },
        cartPieces(){
            return roundMoney(
                this.productCart.reduce( (acc, item) => acc + toNumber(item.cantidad, 0), 0 )
            );
        },
        // El saldo alcanza cuando cubre el total de la venta. La misma regla
        // que aplica `allowToSell()`, para que el pie y el guardado no se
        // contradigan.
        creditIsEnough(){
            const balance = toNumber(this.creditClient?.balance);
            if( balance === null ) return true;
            return toNumber(this.venta.total, 0) <= balance || this.creditClient.allowToBuy === true;
        }
    }
}
</script>

<style scoped>
    /* La tarjeta ocupa todo el diálogo y se divide en tres bandas:
       barra / cuerpo con scroll / pie fijo.
       `.v-dialog--fullscreen` ya mide `height: 100%` del viewport, así que el
       shell se estira a esa altura (no a 100vh: en móvil 100vh es el viewport
       grande y el pie se iría debajo de la barra del navegador). */
    .nv-shell {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .nv-shell__form,
    .nv-shell__inner {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }

    /* Un `v-toolbar` trae `flex: 1 1 auto` de Vuetify: dentro de una columna
       flex que no lo necesita, crece y se come el cuerpo (139px en 1920). */
    .nv-toolbar {
        flex: 0 0 auto;
    }
    .nv-toolbar__title {
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        margin-left: 4px;
        /* Vuetify da 20px al título que sigue a un botón icono (0,5,0);
           con 8px queda a 12px del botón en vez de a 24px. */
        padding-left: 8px !important;
    }
    .nv-toolbar__branch {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, .78);
    }

    /* El botón vive sobre la barra primary: fondo blanco y tinta primary.
       Va como hijo directo de la toolbar, no dentro de `v-toolbar-items`:
       ahí Vuetify fuerza `height: 100%` y `border-radius: 0`.
       El gris de deshabilitado se fija aquí porque el tema dark lo pinta
       blanco translúcido, que sobre blanco es invisible. */
    .nv-submit.v-btn {
        margin-right: 8px;
        background: var(--app-surface) !important;
        color: var(--app-text-muted) !important;
        font-weight: 600;
        letter-spacing: 0;
        text-transform: none;
    }
    .nv-submit.v-btn:not(.v-btn--disabled) {
        color: var(--v-primary-base) !important;
    }
    /* El tema dark pinta icono y spinner en blanco translúcido: sobre el
       blanco del botón desaparecen. Que hereden la tinta del botón. */
    .nv-submit.v-btn .v-icon,
    .nv-submit.v-btn .v-btn__loading {
        color: inherit !important;
    }

    /* El fondo gris (`form-page`) y las tarjetas (`surface-card`) son clases
       globales de main.css; aquí solo el padding responsivo. */
    .nv-body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 20px 24px 28px;
    }
    @media (max-width: 599px) {
        .nv-body { padding: 12px 12px 20px; }
    }

    /* Sello de fecha: misma caja de 30px que `.form-section__head`, para que
       el riel arranque exactamente a la altura del formulario. */
    .nv-stamp {
        display: flex;
        align-items: center;
        gap: 8px;
        min-height: 46px;
        padding: 8px 12px;
        margin-bottom: 16px;
    }
    .nv-stamp__label {
        font-size: 12px;
        font-weight: 700;
        color: var(--app-text-muted);
    }
    .nv-stamp__value {
        font-size: 14px;
        font-weight: 500;
        color: var(--app-text);
    }

    /* Saldo disponible: banda dentro de "Pago y entrega", pegada al medio de
       pago. Es un botón: abre el detalle del crédito. Verde al 10% cuando el
       saldo cubre la venta, rojo al 10% cuando no. La barra mide cuánto del
       saldo consume la venta. */
    .nv-credit {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        margin: 16px 0 16px;
        padding: 10px 12px;
        /* Borde punteado: lee como una nota de contexto, no como un campo. */
        border: 1px dashed color-mix(in srgb, var(--app-primary) 45%, transparent);
        border-radius: 6px;
        background: color-mix(in srgb, var(--app-success) 10%, transparent);
        font: inherit;
        text-align: left;
        cursor: pointer;
        transition: background .15s ease;
    }
    .nv-credit:hover { background: color-mix(in srgb, var(--app-success) 18%, transparent); }
    .nv-credit:focus-visible {
        outline: 2px solid var(--v-primary-base);
        outline-offset: 2px;
    }
    .nv-credit__col {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 0 0 auto;
    }
    .nv-credit__col--end { text-align: right; }
    .nv-credit__label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        font-weight: 700;
        color: var(--app-text-muted);
        white-space: nowrap;
    }
    .nv-credit__col--end .nv-credit__label { justify-content: flex-end; }
    .nv-credit__info {
        font-size: 12px !important;
        color: var(--app-text-muted) !important;
    }
    .nv-credit__value {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: var(--app-text);
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }
    .nv-credit__meter {
        flex: 1 1 auto;
        min-width: 40px;
        height: 6px;
        border-radius: 3px;
        background: color-mix(in srgb, var(--app-success) 25%, transparent);
        overflow: hidden;
    }
    .nv-credit__fill {
        display: block;
        height: 100%;
        background: var(--app-success);
        transition: width .2s ease;
    }
    .nv-credit--short { background: color-mix(in srgb, var(--app-danger) 10%, transparent); border-color: color-mix(in srgb, var(--app-danger) 50%, transparent); }
    .nv-credit--short:hover { background: color-mix(in srgb, var(--app-danger) 18%, transparent); }
    .nv-credit--short .nv-credit__meter { background: color-mix(in srgb, var(--app-danger) 25%, transparent); }
    .nv-credit--short .nv-credit__fill { background: var(--app-danger-ink); }
    .nv-credit--short .nv-credit__col--end .nv-credit__value,
    .nv-credit--short .nv-credit__col--end .nv-credit__label { color: var(--app-danger-ink); }
    @media (max-width: 599px) {
        .nv-credit { gap: 10px; padding: 8px 10px; }
        .nv-credit__value { font-size: 15px; }
        .nv-credit__meter { display: none; }
        .nv-credit__col--end { margin-left: auto; }
    }
    .nv-client {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        padding-top: 8px;
    }
    .nv-client__name {
        font-size: 14px;
        font-weight: 500;
        color: var(--app-text);
    }
    .nv-client__chip { letter-spacing: 0; }
    /* El panel que abre el menú: mismo padding que cualquier superficie. */
    .nv-credit__panel {
        margin: 0;
        padding: 16px;
    }
    /* SingleCalendar trae white--text y margenes propios; se neutralizan
       desde aquí para no tocar el componente compartido. */
    .nv-datepicker ::v-deep .v-text-field {
        margin: 0 !important;
    }
    /* El calendario es el único campo de la fila que no es un `v-autocomplete`
       propio: `SingleCalendar` no expone `filled` y es un componente
       compartido por ~25 vistas, así que no se toca. Se replica aquí lo que
       hace `.v-text-field--filled` (fondo gris + hover más denso) para que la
       fecha se lea igual que sus vecinas. */
    .nv-datepicker ::v-deep .v-input__slot {
        background: var(--app-field);
    }
    .nv-datepicker ::v-deep .v-input:not(.v-input--is-focused):not(.v-input--has-state) .v-input__slot:hover {
        background: var(--app-field-hover);
    }
    /* `SingleCalendar` hardcodea `persistent-hint` y no expone `hide-details`.
       Se replica desde aquí lo que hace `.v-input--hide-details`: quitar el
       margen inferior del slot y la caja de mensajes. Sin esto, el campo de
       fecha reserva 30px vacíos (8 + 14 + 8) bajo el borde. */
    .nv-datepicker ::v-deep .v-input__slot {
        margin-bottom: 0 !important;
    }
    .nv-datepicker ::v-deep .v-text-field__details {
        display: none;
    }
    .nv-datepicker ::v-deep .white--text,
    .nv-datepicker ::v-deep .white--text .v-label,
    .nv-datepicker ::v-deep .white--text .v-messages__message {
        color: var(--app-text-muted) !important;
    }
    .nv-datepicker ::v-deep .white--text input {
        color: var(--app-text) !important;
    }
</style>
